import {Component} from '@angular/core';

@Component({
  selector: 'app-avl-solution-home',
  template: `
    <div class="content">
      <div class="pagehead">
        <h1>Choose a solution</h1>
        <p>
          Browse solutions available to your organisation and subscribe to start
          running them.
        </p>
      </div>
      <app-avl-solutions></app-avl-solutions>
    </div>
  `,
  styleUrls: ['./avl-solution-home.component.scss'],
})
export class AvlSolutionHomeComponent {
}
